module.exports = __webpack_public_path__ + "static/media/16-16.a4cd77f7.mp3";